import { TFunction } from 'i18next'

import { WebsalesUser } from '../types'
import { Td } from './styled-components'
import WebsalesUserRow from './WebsalesUserRow'

interface WebsalesTableBodyProps {
  websalesUsers: WebsalesUser[]
  canDelete: boolean
  t: TFunction
  onEdit: (websalesUser: WebsalesUser) => void
  onToggleStatus: (websalesUser: WebsalesUser) => void
  onDelete: (websalesUserId: number | string) => void
  onRegeneratePassword: (websalesUserId: number | string) => void
}

const WebsalesTableBody = ({
  websalesUsers,
  canDelete,
  t,
  onEdit,
  onToggleStatus,
  onDelete,
  onRegeneratePassword,
}: WebsalesTableBodyProps) => {
  if (websalesUsers.length === 0) {
    return (
      <tr>
        <Td colSpan={6}>{t('websalesUsersManagement:no_results')}</Td>
      </tr>
    )
  }

  return (
    <>
      {websalesUsers.map(websalesUser => (
        <WebsalesUserRow
          key={websalesUser.id}
          websalesUser={websalesUser}
          canDelete={canDelete}
          t={t}
          onEdit={onEdit}
          onToggleStatus={onToggleStatus}
          onDelete={onDelete}
          onRegeneratePassword={onRegeneratePassword}
        />
      ))}
    </>
  )
}

export default WebsalesTableBody
